/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { Injectable } from "@angular/core";
import { MenuEntries } from "@app/models/menu-entries";
import { MenuEntry } from "@app/models/menu-entry";
import { of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AppMenuService {
  private menuEntries: MenuEntries = {
    /* questionnaire: {
      label: "Questionario",
      route: "questionnaire",
      image: "assets/home/btns/questionnaire.svg",
      color: "#00897b"
    }, */

    "apps-tutorial": {
      label: "Apps Tutorials",
      route: "apps-tutorial",
      image: "assets/home/btns/apps-tutorial.svg",
      color: "#039be5",
      hide: of(true),
    },

    "doctor-panel": {
      label: "Cruscotto Clinico",
      route: "doctor-panel/page",
      image: "assets/home/btns/doctor-dashboard.svg",
      color: "#fb8c00",
      hide: of(true),
      // hide set on init
    },

    "multiPatient-panel": {
      label: "Gestione Liste Pazienti",
      route: "patient-group",
      image: "assets/home/btns/patient-list.png",
      color: "#008080",
      hide: of(true),
      // hide set on init
    },

    messages: {
      label: "Messaggistica",
      route: "messages",
      image: "assets/home/btns/messages.svg",
      color: "#2196f3",
      hide: of(true),
    },

    "video-meeting": {
      label: "Videochiamate",
      route: "video-meeting",
      image: "assets/home/btns/video-meeting.svg",
      color: "#1976d2",
      hide: of(true),
    },

    "hospital-administration": {
      label: "Area Amministrativa",
      route: "hospital-administration",
      image: "assets/home/btns/img-add-info-card.svg",
      color: "#d21976",
      hide: of(true),
    },

    authorizations: {
      label: "Gestione Permessi",
      route: "authorizations",
      image: "assets/home/btns/authorizations.svg",
      color: "#546e7a",
      hide: of(true),
    },

    "admin-panel": {
      label: "Pannello Amministrazione",
      route: "external",
      routeQueryParams: { path: "/administration" },
      image: "assets/home/btns/admin-panel.svg",
      color: "#546e7a",
      hide: of(true),
    },

    questionnaires: {
      label: "Questionari",
      route: "questionnaires",
      image: "assets/home/btns/questionnaire.svg",
      color: "#fb8c00",
      hide: of(true),
      // hide set on init
    },

    "enrolment-requests": {
      label: "Richieste di Arruolamento",
      route: "enrolment-requests",
      image: "assets/home/btns/table-account.svg",
      color: "#008080",
      hide: of(true),
      // hide set on init
    },
  };

  /**
   * Returns the menu of the app.
   */
  getMenu(): MenuEntries {
    return this.menuEntries;
  }

  /**
   * Returns the menu of the app as list.
   */
  getMenuList(): MenuEntry[] {
    return Object.values(this.menuEntries);
  }
}
